<template>
  <div
    :aria-label="tagAriaLabel"
    class="tw:mb-1 tw:flex tw:h-fit tw:items-center tw:gap-2 tw:rounded-full tw:py-1.5 tw:pl-2 tw:pr-1"
    :class="tagClass"
    @click="tagClick"
  >
    <span>
      {{ label }}
    </span>
    <BaseIcon :icon="tagIcon" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import BaseIcon from "shared/components/base/BaseIcon.vue";

interface AITagProps {
  disabled?: boolean;
  label: string;
  active?: boolean;
}

const { disabled, label = "", active } = defineProps<AITagProps>();

const emit = defineEmits(["click"]);

const tagAriaLabel = computed<string>(() => {
  if (active) {
    return getLocaleText("ai_tag.remove_suggestion");
  }

  return getLocaleText("ai_tag.add_suggestion");
});

const tagClass = computed<string[]>(() => {
  const classes = [];

  if (active) {
    classes.push("tw:bg-ai-secondary tw:text-white");
  } else {
    classes.push(
      "tag--shadow tw:bg-white tw:text-blue-700 tw:hover:bg-ai-tertiary"
    );
  }

  if (disabled) {
    classes.push("tw:cursor-not-allowed");
  } else {
    classes.push("tw:cursor-pointer");
  }

  return classes;
});

const tagIcon = computed<string>(() => (active ? "close" : "plus"));

function tagClick() {
  if (disabled) return;

  emit("click");
}
</script>

<style lang="scss" scoped>
.tag {
  &--shadow {
    box-shadow:
      0 7px 4px 0 rgb(0 0 0 / 5%),
      0 3px 3px 0 rgb(0 0 0 / 9%),
      0 1px 2px 0 rgb(0 0 0 / 10%);
  }
}
</style>
